import { render, staticRenderFns } from "./ReviewDialog.vue?vue&type=template&id=6fb54138"
import script from "./ReviewDialog.vue?vue&type=script&lang=js"
export * from "./ReviewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fb54138')) {
      api.createRecord('6fb54138', component.options)
    } else {
      api.reload('6fb54138', component.options)
    }
    module.hot.accept("./ReviewDialog.vue?vue&type=template&id=6fb54138", function () {
      api.rerender('6fb54138', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/hour/ReviewDialog.vue"
export default component.exports